export interface AllowListEntry {
  id: string;
  tenant_id: string;
  tenant_name: string;
  value: string;
  type: 'ip' | 'cidr' | 'dns';
  status: 'approved' | 'denied' | 'requested' | 'revoked';
  requested_by_id?: string; // null once the requesting user is deleted
  requested_by_name: string;
  approved_by_id?: string;
  approved_by_name?: string;
  reason?: string;
  created_at: string;
  updated_at: string;
}

export interface AllowListCreateRequest {
  value: string;
  reason?: string;
}

export interface AllowListUpdateRequest {
  status: 'approved' | 'denied' | 'revoked' | 'requested';
  reason?: string;
}

export interface AllowListBulkDeleteResponse {
  deleted: string[];
  failed: { id: string; reason: string }[];
}

export interface AllowListStats {
  total_entries: number;
  approved_entries: number;
  denied_entries: number;
  requested_entries: number;
  revoked_entries: number;
  by_type: Record<string, number>;
}

export const ALLOW_LIST_STATUS_COLORS = {
  approved: 'success',
  denied: 'error',
  requested: 'warning',
  revoked: 'default'
} as const;

export const ALLOW_LIST_TYPE_COLORS = {
  ip: 'primary',
  cidr: 'secondary',
  dns: 'info',
  url: 'warning'
} as const;
